// extracted by mini-css-extract-plugin
module.exports = {"updating":"src_updating__3sqyQ","logo":"src_logo__nxkEw"};